import { Separator } from "@/components/Separator/Separator";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

function BasicCase() {
  return (
    <div className="flex flex-col gap-2">
      <span>Above</span>
      <Separator />
      <span>Below</span>
    </div>
  );
}

function ColorVariants() {
  return (
    <div className="flex flex-col gap-4">
      <Separator className="bg-border" />
      <Separator className="bg-primary" />
      <Separator className="bg-destructive" />
      <Separator className="bg-muted-foreground" />
    </div>
  );
}

function VerticalCase() {
  return (
    <div className="flex h-8 items-center gap-2">
      <span>Left</span>
      <Separator w="1px" h="100%" />
      <span>Right</span>
    </div>
  );
}

function ThicknessAndWidth() {
  return (
    <div className="flex flex-col gap-4">
      <Separator h="2px" />
      <Separator h="4px" />
      <Separator h="1px" w="50%" />
    </div>
  );
}

export function PlaygroundSeparator() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Color Variants</PlaygroundSubSectionTitle>
        <ColorVariants />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Thickness &amp; Width
        </PlaygroundSubSectionTitle>
        <ThicknessAndWidth />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Vertical</PlaygroundSubSectionTitle>
        <VerticalCase />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
